module.exports = __webpack_public_path__ + "img/51_46.05b47c62.png";